module.exports = __webpack_public_path__ + "assets/img/download-tips.eb6eeffc.png";